import 'jwt-decode';
import jwt from 'jsonwebtoken';
class AuthService {
    createAccessToken(userId, { auth }) {
        const token = {
            nameid: 'admin',
            exp: Math.floor(Date.now() / 1000) + 60 * 60 * 120,
            iss: auth.jwt.issuer || 'refract-cms',
            aud: 'refract-cms',
        };
        return jwt.sign(token, auth.jwt.secret);
    }
    verifyAccessToken(token, { auth }) {
        try {
            return jwt.verify(token, auth.jwt.secret);
        }
        catch (error) {
            console.log(error);
            return { nameid: null };
        }
    }
    async findUserIdWithCredentials(username, password, { auth }) {
        if (auth.adminCredentials.username === username && auth.adminCredentials.password === password) {
            return 'ADMIN';
        }
        return null;
    }
}
export const authService = new AuthService();
